import * as Sentry from "@sentry/angular";
import { environment } from "../../../environments/environment";

export class SentryOutput {
  /** Sentryにログ出力する */
  public static sentryOutputLog() {
    const tokenUsername: string = localStorage.getItem(`CognitoIdentityServiceProvider.${environment.amplify.Auth.userPoolWebClientId}.LastAuthUser`);
    Sentry.setContext("userInfo", {
      tokenUsername: tokenUsername,
    });
    Sentry.captureMessage(`Angular(${environment.website}) / username: ${tokenUsername}`);
  }

  /** Sentryにエラーログ出力する */
  public static sentryOutputErrorLog(exception: any) {
    const tokenUsername: string = localStorage.getItem(`CognitoIdentityServiceProvider.${environment.amplify.Auth.userPoolWebClientId}.LastAuthUser`);
    Sentry.setContext("userInfo", {
      tokenUsername: tokenUsername,
    });
    Sentry.captureException(exception);
  }
}
